/**
 * Cross-tenant guard for IMC users (MV-2687): MV and DN share one Kinde
 * application and SSO session, so an IMC user can authenticate on the wrong
 * product's host. When the API reports a calling/expected tenant mismatch,
 * send them to the expected tenant's login with autoLogin so the shared SSO
 * session signs them straight in.
 *
 * The host change is the one navigation that genuinely requires
 * window.location — the SPA (and the Kinde SDK's in-memory session) cannot
 * cross origins.
 *
 * @param {Object} tenant - user.tenant from the API ({ calling, expected })
 * @param {Object} [options]
 * @param {string} [options.redirectTo] - same-origin path to restore after
 *   the auto-login on the expected tenant completes
 * @returns {boolean} true when a redirect was issued — callers must stop
 *   their flow immediately
 */
export function redirectToExpectedTenant(tenant, { redirectTo } = {}) {
  if (
    !tenant?.calling?.uid ||
    !tenant?.expected?.uid ||
    tenant.calling.uid === tenant.expected.uid
  ) {
    return false
  }

  console.error(
    'IMC user attempted to access wrong tenant URL. Expected:',
    tenant.expected.networkDomain,
    'Actual:',
    window.location.hostname,
  )

  const target = new URL(
    `${window.location.protocol}//${tenant.expected.networkDomain}/login`,
  )
  target.searchParams.set('autoLogin', 'true')
  if (redirectTo) {
    target.searchParams.set('redirectTo', redirectTo)
  }
  window.location.href = target.toString()
  return true
}
